import { MapPin, Clock, Phone, Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { MAPS_DIRECTIONS, MAPS_EMBED, WHATSAPP_URL } from "../data/content";

const VisitUs = () => (
    <section id="visit" data-testid="visit-us-section" className="bg-heritage-parchment py-24 md:py-36">
        <div className="mx-auto max-w-7xl px-5 md:px-10">
            <Reveal className="max-w-2xl">
                <Eyebrow>Visit Us</Eyebrow>
                <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-heritage-ink sm:text-4xl lg:text-5xl">
                    Plan Your <em className="text-heritage-terra">Visit</em> to IHCC
                </h2>
            </Reveal>

            <div className="mt-16 grid gap-10 lg:grid-cols-[1fr_1.2fr]">
                <div className="flex flex-col gap-5">
                    <Reveal delay={0.05}>
                        <div data-testid="visit-address-info" className="rounded-2xl border border-heritage-terra/12 bg-heritage-cream p-7">
                            <MapPin size={22} strokeWidth={1.6} className="text-heritage-terra" />
                            <h3 className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-heritage-ink/55">
                                Address
                            </h3>
                            <p className="mt-2 font-serif text-xl font-semibold text-heritage-ink">
                                Indian Heritage Cultural Centre
                            </p>
                            <p className="mt-1 text-sm leading-relaxed text-heritage-ink/70">
                                57 Lebuh Pantai, George Town, Penang, Malaysia — in the historic
                                heart of the UNESCO heritage zone
                            </p>
                            <a
                                href={MAPS_DIRECTIONS}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="visit-directions-link"
                                className="mt-4 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.22em] text-heritage-terra transition-colors hover:text-heritage-vermilion"
                            >
                                Get Directions <ArrowUpRight size={14} />
                            </a>
                        </div>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <div data-testid="visit-hours-info" className="rounded-2xl border border-heritage-terra/12 bg-heritage-cream p-7">
                            <Clock size={22} strokeWidth={1.6} className="text-heritage-terra" />
                            <h3 className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-heritage-ink/55">
                                Opening Hours
                            </h3>
                            <p className="mt-2 font-serif text-xl font-semibold text-heritage-ink">
                                10:00 AM – 7:00 PM · Daily
                            </p>
                            <p className="mt-1 text-sm text-heritage-ink/70">
                                Open every day of the week. The hosted journey takes about 1 hour
                                30 minutes.
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={0.15}>
                        <div data-testid="visit-contact-info" className="rounded-2xl border border-heritage-terra/12 bg-heritage-cream p-7">
                            <div className="flex flex-wrap gap-x-10 gap-y-4">
                                <div>
                                    <Phone size={22} strokeWidth={1.6} className="text-heritage-terra" />
                                    <h3 className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-heritage-ink/55">
                                        Phone
                                    </h3>
                                    <a
                                        href="tel:+6042260264"
                                        data-testid="visit-phone-link"
                                        className="mt-2 block font-serif text-xl font-semibold text-heritage-ink transition-colors hover:text-heritage-terra"
                                    >
                                        +604 226 0264
                                    </a>
                                </div>
                                <div>
                                    <Mail size={22} strokeWidth={1.6} className="text-heritage-terra" />
                                    <h3 className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-heritage-ink/55">
                                        Email
                                    </h3>
                                    <a
                                        href="mailto:galleryihcc@gmail.com"
                                        data-testid="visit-email-link"
                                        className="mt-2 block font-serif text-xl font-semibold text-heritage-ink transition-colors hover:text-heritage-terra"
                                    >
                                        galleryihcc@gmail.com
                                    </a>
                                </div>
                                <div>
                                    <MessageCircle size={22} strokeWidth={1.6} className="text-heritage-terra" />
                                    <h3 className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-heritage-ink/55">
                                        WhatsApp
                                    </h3>
                                    <a
                                        href={WHATSAPP_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid="visit-whatsapp-link"
                                        className="mt-2 inline-flex items-center gap-1.5 font-serif text-xl font-semibold text-heritage-ink transition-colors hover:text-heritage-terra"
                                    >
                                        Sales &amp; Marketing Group <ArrowUpRight size={15} />
                                    </a>
                                    <p className="mt-1 text-sm text-heritage-ink/70">
                                        Chat with our team about visits, groups and partnerships.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.1} className="relative">
                    <div className="absolute -right-4 -top-4 hidden h-full w-full rounded-2xl border border-heritage-gold/40 md:block" />
                    <iframe
                        src={MAPS_EMBED}
                        data-testid="visit-google-map-iframe"
                        title="Map — Indian Heritage Cultural Centre, 57 Lebuh Pantai, George Town, Penang"
                        className="relative h-[420px] w-full rounded-2xl border border-heritage-terra/15 lg:h-full lg:min-h-[520px]"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                    />
                </Reveal>
            </div>
        </div>
    </section>
);

export default VisitUs;
